import useTaskListItem, { generateUrls as generateTaskUrls } from '@hooks/useTaskListItem'
import useTaskListItems from '@hooks/useTaskListItems'

import type { TaskListItemModel, TemplatePageModel } from '@models/types'

type UseTemplateTestingLinkOptions = {
  taskListItem: TaskListItemModel,
  templatePage: TemplatePageModel,
}

function useTemplateTestingLink(options: UseTemplateTestingLinkOptions) {
  const { taskListItem, templatePage } = options

  const taskListItemPayload = useTaskListItem(taskListItem)
  const {
    callbacks: {
      setupTemplateTestingEntities,
    },
    taskListItem: {
      artwork_id,
      id,
    },
  } = taskListItemPayload

  const taskListItemsPayload = useTaskListItems({
    filters: {
      parent_task_id: id,
      sub_tasks: true,
      template_project: true,
    },
  })
  const { filteredTaskListItems } = taskListItemsPayload
  const lastSubTask = filteredTaskListItems[filteredTaskListItems.length - 1] || {}

  const { testTaskListItemArtworkUrl } = generateTaskUrls(taskListItem, { includeRedirect: true })

  const hasArtwork = !!artwork_id

  return {
    buttonText: hasArtwork ? 'Test' : 'Setup Test',
    callbacks: {
      onClick: !hasArtwork ? () => setupTemplateTestingEntities() : null,
    },
    disabled: !templatePage.id,
    hasArtwork,
    href: hasArtwork ? `${testTaskListItemArtworkUrl}&subTaskId=${lastSubTask.id}` : null,
  }
}

export default useTemplateTestingLink
